// extracted by mini-css-extract-plugin
export default {"v-asphalt":"#D8D8D8","cell":"cells__cell__VfQQC","cell0":"cells__cell0__ZvyoH cells__cell__VfQQC"};